window.POC = window.POC || {};

(function installProductDemoAllProductsLabelFix() {
  function shouldShowCategoryCounts() {
    var settings =
      POC.state &&
      POC.state.storefrontDisplaySettings &&
      POC.state.storefrontDisplaySettings.productGrid;

    return !settings || settings.showCategoryCounts !== false;
  }

  function getAllProductsCount() {
    var state = POC.state || {};
    var allPayload =
      state.productsByCategory &&
      state.productsByCategory.ALL;

    var count = Number(
      state.sidebarAllCount ||
      (allPayload && allPayload.total) ||
      (allPayload && allPayload.count) ||
      0
    );

    return Number.isFinite(count) && count >= 0 ? count : 0;
  }

  function repairAllProductsLabel() {
    var state = POC.state || {};
    var isLoading = !!(
      state.sidebar &&
      state.sidebar.loadingAll
    );

    if (isLoading) return;

    var button =
      document.querySelector('[data-category-id="ALL"]');

    if (!button) return;

    button.classList.remove("is-loading");
    button.removeAttribute("aria-busy");

    var count = getAllProductsCount();
    var text = String(button.textContent || "");
    var countEl = button.querySelector(".poc-demo-tree__count");

    if (countEl) {
      countEl.textContent = "(" + count + ")";
      return;
    }

    if (
      /loading/i.test(text) ||
      !text.trim() ||
      !/\(\d+\)/.test(text)
    ) {
      button.textContent = shouldShowCategoryCounts()
        ? "All Products (" + count + ")"
        : "All Products";
    }
  }

  function install() {
    if (!POC.core || !POC.render) {
      window.setTimeout(install, 50);
      return;
    }

    if (
      typeof POC.core.setSidebarAllLoading === "function" &&
      !POC.core.setSidebarAllLoading.__allProductsLabelWrapped
    ) {
      var originalSetSidebarAllLoading =
        POC.core.setSidebarAllLoading.bind(POC.core);

      var wrappedSetSidebarAllLoading = function (isLoading) {
        var result =
          originalSetSidebarAllLoading(isLoading);

        if (!isLoading) {
          window.requestAnimationFrame(
            repairAllProductsLabel
          );
        }

        return result;
      };

      wrappedSetSidebarAllLoading.__allProductsLabelWrapped =
        true;

      POC.core.setSidebarAllLoading =
        wrappedSetSidebarAllLoading;
    }

    if (
      typeof POC.render.renderCategories === "function" &&
      !POC.render.renderCategories.__allProductsLabelWrapped
    ) {
      var originalRenderCategories =
        POC.render.renderCategories.bind(POC.render);

      var wrappedRenderCategories = function () {
        var result =
          originalRenderCategories.apply(
            POC.render,
            arguments
          );

        window.requestAnimationFrame(
          repairAllProductsLabel
        );

        return result;
      };

      wrappedRenderCategories.__allProductsLabelWrapped =
        true;

      POC.render.renderCategories =
        wrappedRenderCategories;
    }

    window.POC_ALL_PRODUCTS_LABEL_FIX_ACTIVE = true;

    repairAllProductsLabel();
    window.setTimeout(repairAllProductsLabel, 300);
    window.setTimeout(repairAllProductsLabel, 1000);
    window.setTimeout(repairAllProductsLabel, 2000);

    console.info(
      "[POC All Products label fix] Installed"
    );
  }

  install();
})();